export enum CreditCardProviderEnum {
  Visa = 'visa',
  MasterCard = 'masterCard',
  AmericanExpress = 'americanExpress',
  DinersClub = 'dinersClub',
  Discover = 'discover',
  Elo = 'elo',
  Hiper = 'hiper',
  Hipercard = 'hipercard',
  Jcb = 'jcb',
  Maestro = 'maestro',
  Mir = 'mir',
  Unionpay = 'unionpay',
}
